import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const DELETE_THREADS = createAsyncActionTypes('DELETE_THREADS');
export const MARK_THREADS_AS_CLOSED = createAsyncActionTypes('MARK_THREADS_AS_CLOSED');
export const RESTORE_THREADS = createAsyncActionTypes('RESTORE_THREADS');